module.exports = __webpack_public_path__ + "static/img/device2.84e4f289.png";